import { render, staticRenderFns } from "./customerFree.vue?vue&type=template&id=2dcb2b44&"
import script from "./customerFree.vue?vue&type=script&lang=js&"
export * from "./customerFree.vue?vue&type=script&lang=js&"
import style0 from "./customerFree.vue?vue&type=style&index=0&id=2dcb2b44&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports